// src/redux/store.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import hotelReducer from "./hotelSlice";
import configReducer from "./configSlice";
import mediaReducer from "./mediaSlice";

import { persistReducer, persistStore } from "redux-persist";

import storageSession from "redux-persist/lib/storage/session"; // ✅ correct storage

import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

const persistConfig = {
  key: "root",
  storage: storageSession, // ✅ FIXED
  whitelist: ["hotel", "config", "media"],
};

const rootReducer = combineReducers({
  hotel: hotelReducer,
  config: configReducer,
  media: mediaReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefault) =>
    getDefault({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
